### 1. Update the Component

<!-- 语言选择器 -->
<template>
  <div class="language-selector" ref="dropdown" @click="toggleDropdown">
    <div class="selected-language" :class="{ dark: isDarkMode }">
      <span class="icon">
        <img :src="isDarkMode ? ic_internet_white : ic_internet_black" alt="internet icon" />
      </span>
      {{ currentShowLanguage }}
      <span class="arrow" :class="{ open: isOpen }">
        <img
          :src="
            isOpen ? (isDarkMode ? ic_arrow_up_white : ic_arrow_up) : isDarkMode ? ic_arrow_down_white : ic_arrow_down
          "
          alt="arrow"
        />
      </span>
    </div>
    <div v-if="isOpen" class="dropdown">
      <!-- 需要key -->
      <div
        v-for="(value, key, id) in state.languageList"
        :key="index"
        @click="selectLanguage(key)"
        class="dropdown-item"
      >
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch, reactive } from 'vue';
import ic_arrow_down from './imgs/ic_arrow_down.png';
import ic_arrow_up from './imgs/ic_arrow_up.png';
import ic_arrow_down_white from './imgs/ic_arrow_down_white.png';
import ic_arrow_up_white from './imgs/ic_arrow_up_white.png';
import ic_internet_white from './imgs/ic_internet_white.svg';
import ic_internet_black from './imgs/ic_internet_black.svg';
import { useAppStore } from '@/stores/index';
import { useRouter } from 'vue-router';
const appStore = useAppStore();
const router = useRouter();
// 引入i18n
import { i18n } from '@/utils/i18n';

const props = defineProps({
  isDarkMode: Boolean, // Prop to toggle dark mode
});

// 当前语言
const currentLanguage = ref(appStore.lang);
// 当前显示语言
const currentShowLanguage = computed(() => {
  return state.languageList[i18n.global.locale];
});

// 是否打开
const isOpen = ref(false);
// 下拉框
const dropdown = ref(null);

// { // 语言列表
//                 'zh_CN': 'zh_CN',
//                 'en': 'en',
//                 'th': 'th'
//             }
const state = reactive({
  languageList: appStore.config.languageList,
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

// 监听语言变化
watch(
  () => appStore.lang,
  (newValue) => {
    console.log('Language changed:', newValue);
    currentLanguage.value = newValue;
  },
);

// 需要刷新页面的路由列表
const shouldRefreshPageList = ['/claimTracking/result'];
// 选择语言
const selectLanguage = (language) => {
  currentLanguage.value = language;
  isOpen.value = false;
  appStore.setLang(currentLanguage.value);
  if (shouldRefreshPageList.includes(router.currentRoute.value.path)) {
    router
      .push({
        path: router.currentRoute.value.path,
        query: { ...router.currentRoute.value.query, lang: currentLanguage.value },
      })
      .then(() => {
        window.location.reload();
      });
  }
};

// 点击外部
const handleClickOutside = (event) => {
  if (dropdown.value && !dropdown.value.contains(event.target)) {
    isOpen.value = false;
  }
};

// 挂载
onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

// 卸载
onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
// pc
@media screen and (min-width: $screen_min_width) {
  .language-selector {
    position: relative;
    display: inline-block;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
  }

  .selected-language {
    display: flex;
    align-items: center;
    color: black;
    font-size: 28px;
    font-weight: 400;
    line-height: 32.81px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    /* Default color */
  }

  .selected-language.dark {
    color: white;
    /* Dark mode color */
  }

  .icon {
    margin-right: 5px;

    img {
      display: block;
      width: 32px;
      height: 32px;
    }
  }

  .arrow {
    margin-left: 5px;
    transition: transform 0.3s;

    img {
      display: block;
      width: 16px;
      height: 12px;
    }
  }

  .arrow.open {
    transform: rotate(180deg);
  }

  .dropdown {
    position: absolute;
    top: 100%;
    left: -50px;
    /* background: url("./imgs/bg_popup.svg") no-repeat cover; */
    background-color: white;
    color: black;
    border: 1px solid #ccc;
    border-radius: 12px;
    width: auto;

    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    z-index: 1000;
  }

  .dropdown-item {
    padding: 10px 40px;
    font-size: 28px;
    line-height: 36px;
    text-align: justify;
    cursor: pointer;
  }

  .dropdown-item:hover {
    background-color: #f0f0f0;
  }
}

// 移动端
@media screen and (max-width: $screen_min_width) {
  .language-selector {
    position: relative;
    display: inline-block;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
  }

  .selected-language {
    display: flex;
    align-items: center;
    color: black;
    font-size: 28px;
    font-weight: 400;
    line-height: 32.81px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    white-space: nowrap;
    /* Default color */
  }

  .selected-language.dark {
    color: white;
    /* Dark mode color */
  }

  .icon {
    margin-right: 5px;

    img {
      display: block;
      width: 32px;
      height: 32px;
    }
  }

  .arrow {
    margin-left: 5px;
    transition: transform 0.3s;

    img {
      display: block;
      width: 16px;
      height: 12px;
    }
  }

  .arrow.open {
    transform: rotate(180deg);
  }

  .dropdown {
    position: absolute;
    top: 100%;
    left: -50px;
    /* background: url("./imgs/bg_popup.svg") no-repeat cover; */
    background-color: white;
    color: black;
    border: 1px solid #ccc;
    border-radius: 12px;
    width: auto;

    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    z-index: 1000;
  }

  .dropdown-item {
    padding: 10px 40px;
    font-size: 28px;
    line-height: 36px;
    text-align: justify;
    cursor: pointer;
  }

  .dropdown-item:hover {
    background-color: #f0f0f0;
  }
}
</style>
